import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { appendModel } from '../../../../../features/site/siteSlice'

import { serviceMap } from '../../../../utils/common'
import LinkedInClaimCard from '../../../Admin/ServiceTypes/LinkedInAds'

import ServiceCardBase from '../../ServiceCardBase'

function LinkedInAds({ onSave, onCancel}){
    const dispatch = useDispatch()
    
    const model = useSelector(state => state.site.model)
    const oauthTokens = useSelector(state => state.session.oauthTokens)

    const site = model?.sites[model.siteActiveIdx]

    const { siteForm } = model

    const editSite = async() => {
        await dispatch(appendModel({
            siteForm: {
                ...siteForm,
                attr: {
                    ...siteForm.attr,
                    accounts: {
                        ...(siteForm?.attr?.accounts ?? {}),
                        linkedin: undefined
                    }
                }
            }
        }))
    }


    return <ServiceCardBase 
        title="LinkedIn Ads" 
        header="LinkedIn Ads" 
        description=" "
        image={serviceMap.linkedin.img}>
            <LinkedInClaimCard design="onboarding" />
            <div class="d-flex flex-row-reverse justify-content-between">
                <div>
                    {siteForm?.attr?.accounts?.linkedin && <button className="mr-3 btn btn-lg btn-outline-primary" onClick={() => editSite()}>
                        Edit
                    </button>}
                    {siteForm?.attr?.accounts?.linkedin && oauthTokens?.linkedin ? <button id="saveLinkedin" className="btn btn-lg btn-primary" onClick={async() => {
                        await onSave("linkedin")
                    }}>Save</button> : <div></div>}
                </div>
                {(!siteForm?.attr?.accounts?.linkedin || localStorage.getItem("linkedinSelection") === null) && <button className="btn btn-lg btn-link" onClick={() =>onCancel("linkedin")}>Claim Later</button>}
            </div>
    </ServiceCardBase>
}

export default LinkedInAds